/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FilterDtoFromJSON, FilterDtoToJSON, } from './FilterDto';
/**
 * Check if a given object implements the CreateCustomFolderDto interface.
 */
export function instanceOfCreateCustomFolderDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('parentId' in value) || value['parentId'] === undefined)
        return false;
    if (!('filters' in value) || value['filters'] === undefined)
        return false;
    return true;
}
export function CreateCustomFolderDtoFromJSON(json) {
    return CreateCustomFolderDtoFromJSONTyped(json, false);
}
export function CreateCustomFolderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'parentId': json['parentId'],
        'filters': FilterDtoFromJSON(json['filters']),
    };
}
export function CreateCustomFolderDtoToJSON(json) {
    return CreateCustomFolderDtoToJSONTyped(json, false);
}
export function CreateCustomFolderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'parentId': value['parentId'],
        'filters': FilterDtoToJSON(value['filters']),
    };
}
